import axios from 'axios'
import jwtService from './jwt.service'
import { createUrl } from '@/utils/helpers'
import environment from '../../environment'

export const apiService = axios.create({
  baseURL: createUrl(
    environment.backendSecure,
    environment.backendUrl,
    environment.backendPort
  ),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

apiService.interceptors.request.use((config) => {
  const token = jwtService.getToken()
  if (token) config.headers.Authorization = `Token ${token}`
  return config
})

export const apiServiceApi = axios.create({
  baseURL: createUrl(
    environment.apiSecure,
    environment.apiUrl,
    environment.apiPort
  ),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

apiServiceApi.interceptors.request.use((config) => {
  const token = jwtService.getToken()
  if (token) config.headers.Authorization = `Token ${token}`
  return config
})

export const apiServiceAgent = axios.create({
  baseURL: createUrl(
    environment.agentSecure,
    environment.agentUrl,
    environment.agentPort
  ),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

apiServiceAgent.interceptors.request.use((config) => {
  const token = jwtService.getToken()
  if (token) config.headers.Authorization = `Token ${token}`
  return config
})
